import type { BlogPost } from "./types";

// Image guidance from source doc (photo omitted for now; add to public/blog/ later):
//  *   EU map with digital accessibility icons and the EAA directive symbol — alt: "Map of Europe overlaid with digital accessibility icons representing the European Accessibility Act enforcement across 27 member states"
//  *   WCAG 2.2 Level AA conformance checklist document — alt: "WCAG 2.2 Level AA success criteria checklist showing the technical requirements mandated under the European Accessibility Act"
const post: BlogPost = {
  slug: "european-accessibility-act-what-indian-businesses-must-know",
  title: "The European Accessibility Act and Indian Businesses",
  metaTitle: "European Accessibility Act: Guide for India",
  subtitle:
    "The EAA has been enforceable since 28 June 2025. What it covers, why Indian exporters and SaaS companies are affected, and what to do.",
  date: "2026-07-21",
  photo: "/blog/european-accessibility-act-what-indian-businesses-must-know.svg",
  alt:
    "Map of Europe overlaid with digital accessibility icons representing the European Accessibility Act enforcement across 27 member states",
  author: "AccessBharat",
  tag: "Global Compliance",
  excerpt:
    "The EAA has been enforceable since 28 June 2025. What it covers, why Indian exporters and SaaS companies are affected, and what to do.",
  body: `The European Accessibility Act (EAA), Directive 2019/882, became enforceable across all 27 EU member states on 28 June 2025. Companies selling digital products and services into Europe now have to meet it. That includes Indian exporters, SaaS companies and digital agencies with EU clients.

## What the EAA covers

The Act applies to a wide range of digital products and services: e-commerce sites, banking and financial service apps, e-books, audio-visual streaming platforms, ticketing machines and passenger transport booking portals. If your product or service reaches EU customers through a website, mobile app or software, check whether it falls into one of these categories.

## The technical standard

The standard most often used to show conformance is EN 301 549 v3.2.1, which incorporates WCAG 2.1 Level AA. Newer revisions of the standard are expected to move to WCAG 2.2, so many teams audit against 2.2 now to avoid doing the work twice. Either way, expect scrutiny of keyboard focus, target size and authentication that does not depend on solving a puzzle.

## Why Indian companies are in scope

It is a common misconception that the EAA only matters if you are incorporated in Europe. It applies based on where your customers are, not where your company is registered. If an Indian SaaS platform sells subscriptions to French businesses, or an Indian e-commerce company runs a European storefront, that digital presence has to meet the Act's requirements. Microenterprises that provide services have an exemption, so check your size before assuming you are covered.

Each member state has named a market surveillance authority, and penalties differ by country. In B2B sales, being unable to show an accessibility declaration can cost you the deal well before a regulator gets involved.

## What to do

1. Audit your web and app interfaces against WCAG 2.2 Level AA and list the gaps.
2. Fix the high-traffic pages first: checkout, login, account management and navigation.
3. Produce an Accessibility Conformance Report (ACR, the completed VPAT) and publish an accessibility statement on your site.

EU enterprise buyers increasingly ask for these documents during procurement, and having them ready shows due diligence.

## An advantage for Indian tech companies

Companies that audit, fix and document their accessibility now will be easier to buy from for EU clients who are working through the EAA themselves. In a crowded SaaS market, an accessibility-ready product helps you stand out, and in procurement it can decide whether you make the shortlist.
`,
};

export default post;
